import { EnglishArabicDTO } from "bnsights-control-library"
export class EmailTemplateTesterModel
{
      TemplateID:number
      LangKey :string
      ToEmail :string
      EmailProviderName:string
      KeyMap: Record<string,string>
      ErrorMessage:string
      IsSuccess:boolean


}